module.exports = __webpack_public_path__ + "img/golfigo3.4476457b.png";